// 記事コンテンツ専用 Webpack エントリーポイント（jQuery 非依存・高速要件）
// - Tailwind CSS（記事専用ビルド）をこの pack にバンドル
// - Stimulus（記事用コントローラーのみ）
// - Lucide アイコン（npm バンドル。CDN script は使わない）
// ※ Chart.js はデータコラム(D-1/D-2)実装時に articles/ 配下のチャートモジュールで
//   `import Chart from 'chart.js/auto'` する。Phase 0 では未使用のためバンドルしない。
import '../articles/index.scss'
import '../articles/articles_turbolinks' // Turbolinks（記事レイアウトは application pack を読まないため明示的に起動）
import '../articles/stimulus'
import { createIcons } from 'lucide'
import { icons } from '../articles/lucide_icons'

// Lucide の初期化は turbolinks:load のみ（javascript.md: DOMContentLoaded 禁止 / 二重登録しない）
document.addEventListener('turbolinks:load', () => {
  createIcons({ icons })
})
